/* PostNL Custom CSS Styling
November 2019 - Domanireport / SupQuest / Tangelo */

// Interactive main menu

$(document).ready(function() {
	 $(".postnl-menuitem").hover(function(e) {
			 var dropdownMenu = $(this).children("a").attr("id");
			 $("#" + dropdownMenu).dropdown("toggle");
	 });

});

// When there is a normal click, open the href!

$(".postnl-menuitem a").click( function(e) {
	$(location).attr('href', $(this).attr("href"));
});

// Left menu interaction (Desktop)

$(".postnl-leftmenu.childs").click( function(e) {

	e.preventDefault();
	$(this).toggleClass("open");
	$("#" + e.target.id + "-child").toggle();

});

// Swap chevron on menu click..

$(".postnl-topitem").click( function(e) {
	$(this).find('.fas').toggleClass('fas fa-chevron-up fas fa-chevron-down');
});

// Add page action..

$(".postnl-addpage").click( function(e) {

	e.preventDefault();
	$("html, body").animate({ scrollTop: 0 }, 500);
	$("#downloadsMenu").find('.fas').toggleClass('fas fa-chevron-up fas fa-chevron-down');
	$("#downloadsMenu").dropdown("toggle");
	return false;

});

// Toggl mobile menu..

$(".postnl-mobilemenu-icon").click( function(e) {
	e.preventDefault();
	$(".postnl-topmenuitems").toggle();
});
